import { Checkbox, Col, Form, Row, Spin } from "antd";
import { FC, useMemo } from "react";
import { ServiceType } from "~/utils/constants";
import { useQuery } from "@tanstack/react-query";
import { addOnServicesApi, AddOnServiceDto } from "~/services/add-on-services";

// Map ServiceType to backend add-on service type
const serviceTypeToAddOnType: Record<
  ServiceType,
  "WAREHOUSE" | "FABRICATION" | "GENERAL"
> = {
  [ServiceType.COLLECTION]: "GENERAL",
  [ServiceType.DELIVERY]: "GENERAL",
  [ServiceType.ON_SITE_SERVICE]: "GENERAL",
  [ServiceType.FABRICATION_SERVICE]: "FABRICATION",
  [ServiceType.WAREHOUSE_SERVICE]: "WAREHOUSE",
};

type Props = {};

export const AddOnServices: FC<Props> = () => {
  const form = Form.useFormInstance();
  const serviceType = Form.useWatch("serviceType", form) as ServiceType;
  const addOnType = serviceTypeToAddOnType[serviceType];

  const { data, isLoading } = useQuery({
    queryKey: ["add-on-services", addOnType],
    queryFn: () => addOnServicesApi.getAll({ type: addOnType }),
    enabled: !!addOnType,
  });

  const options = useMemo(() => (data || []).filter((s) => s.isActive), [data]);

  return (
    <Form.Item label="Add-on Services" name="addOnServices">
      {isLoading ? (
        <Spin />
      ) : (
        <Checkbox.Group className="w-full">
          <Row gutter={[12, 12]}>
            {options.map((addon: AddOnServiceDto) => (
              <Col span={12} key={addon.id}>
                <Checkbox value={addon.id}>{addon.name}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      )}
    </Form.Item>
  );
};
